import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/Services.css";

const Services = () => {
  const { location } = useParams();
  const navigate = useNavigate();
  const [selectedLocation, setSelectedLocation] = useState(location || "indore");

  const services = [
    {
      id: 1,
      title: "Periodic Service",
      description: "Keep your car running smoothly with regular maintenance packages tailored to your car's needs.",
      icon: "🔧",
      features: ["Engine Oil Replacement","Oil Filter Change","Air Filter Cleaning","AC Filter Cleaning","Brake Fluid Top-up","Coolant Top-up","Battery Water Top-up","Wiper Fluid Top-up"],
      price: "Starting from ₹2,499",
      popular: true
    },
    {
      id: 2,
      title: "AC Service & Repair",
      description: "Complete AC maintenance including gas refill, cleaning, and repair services.",
      icon: "❄️",
      features: ["AC Gas Refill","AC Filter Replacement","Condenser Cleaning","Compressor Check","Cooling Coil Cleaning","AC Vent Cleaning"],
      price: "Starting from ₹1,899"
    },
    {
      id: 3,
      title: "Car Detailing & Cleaning",
      description: "Premium car cleaning services - interior, exterior, and complete detailing packages.",
      icon: "✨",
      features: ["Interior Deep Cleaning","Exterior Washing & Polishing","Dashboard Polishing","Seat Shampooing","Carpet Cleaning","Paint Protection","Ceramic Coating","Teflon Coating"],
      price: "Starting from ₹1,299"
    },
    {
      id: 4,
      title: "Denting & Painting",
      description: "Professional body repair and painting services to restore your car's appearance.",
      icon: "🎨",
      features: ["Minor Dent Removal","Major Body Repair","Scratch Removal","Full Body Painting","Door Panel Replacement","Bumper Repair & Paint"],
      price: "Starting from ₹2,999"
    },
    {
      id: 5,
      title: "Battery Services",
      description: "Battery health check, replacement, and maintenance services.",
      icon: "🔋",
      features: ["Battery Health Check","Battery Replacement","Terminal Cleaning","Charging System Check","Alternator Testing"],
      price: "Starting from ₹999"
    },
    {
      id: 6,
      title: "Tyres & Wheel Care",
      description: "Complete tyre services including replacement, alignment, and balancing.",
      icon: "⚙️",
      features: ["Tyre Replacement","Wheel Alignment","Wheel Balancing","Tyre Rotation","Puncture Repair","Nitrogen Filling"],
      price: "Starting from ₹499"
    },
    {
      id: 7,
      title: "Brake Service",
      description: "Complete brake system inspection, repair, and replacement services.",
      icon: "🛑",
      features: ["Brake Pad Replacement","Brake Disc Resurfacing","Brake Fluid Change","Brake Line Inspection","ABS System Check"],
      price: "Starting from ₹1,499"
    },
    {
      id: 8,
      title: "Car Insurance",
      description: "Comprehensive car insurance renewal and claim assistance services.",
      icon: "🛡️",
      features: ["Policy Renewal","Claim Assistance","Zero Depreciation Cover","Third Party Insurance","Comprehensive Insurance","Add-on Covers"],
      price: "Best Rates Available",
      badge: "New"
    },
    {
      id: 9,
      title: "Pre-Purchase Inspection",
      description: "Thorough 150+ point inspection before buying a used car.",
      icon: "🔍",
      features: ["Engine Diagnostics","Body & Paint Check","Suspension Test","Brake System Check","Electrical System Test","Test Drive Analysis","Documentation Verification","Detailed Report"],
      price: "₹999 Only"
    },
    {
      id: 10,
      title: "24/7 Roadside Assistance",
      description: "Emergency breakdown support available round the clock across the city.",
      icon: "🚗",
      features: ["Towing Service","Flat Tyre Change","Battery Jump Start","Fuel Delivery","Minor Repairs On-Site","Lockout Assistance"],
      price: "₹399/month",
      badge: "Popular"
    },
    {
      id: 11,
      title: "Engine Repair & Overhaul",
      description: "Expert engine diagnostics and repair services for all car brands.",
      icon: "🔨",
      features: ["Engine Diagnostics","Oil Leak Repair","Head Gasket Replacement","Timing Belt Replacement","Engine Overhaul","Performance Tuning"],
      price: "Starting from ₹4,999"
    },
    {
      id: 12,
      title: "Transmission Service",
      description: "Automatic and manual transmission repair and maintenance.",
      icon: "⚡",
      features: ["Transmission Fluid Change","Clutch Replacement","Gearbox Repair","Transmission Overhaul","CVT Service"],
      price: "Starting from ₹3,499"
    }
  ];

  const serviceCategories = [
    { name: "Express Services", description: "Quick 30-minute services", icon: "⚡" },
    { name: "Home Service", description: "Doorstep car care", icon: "🏠" },
    { name: "Multi-Brand Workshop", description: "All brands serviced", icon: "🏭" },
    { name: "Genuine Parts", description: "OEM & aftermarket", icon: "✅" }
  ];

  const benefits = [
    { icon: "⚡", title: "Quick Service", desc: "Fast turnaround with express service options" },
    { icon: "👨‍🔧", title: "Expert Technicians", desc: "Certified professionals with 10+ years of experience" },
    { icon: "💰", title: "Transparent Pricing", desc: "No hidden charges — pay only for what you need" },
    { icon: "✅", title: "Genuine Parts", desc: "OEM and quality aftermarket parts with warranty" },
    { icon: "🏠", title: "Doorstep Service", desc: "Select services at your home or office" },
    { icon: "🛡️", title: "Service Warranty", desc: "Up to 6 months warranty on parts and labor" },
  ];

  useEffect(() => {
    if (location) setSelectedLocation(location);
  }, [location]);

  const getDisplayLocation = () =>
    selectedLocation.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");

  return (
    <div className="services-page">

      {/* ── COMING SOON HERO BANNER ── */}
      <section className="services-coming-soon-banner">
        <div className="cs-banner-content">

          <div className="cs-badge">
            <span className="cs-badge-dot" />
            Launching 2026 · Indore, Mhow, Ujjain, Dewas &amp; Pithampur
          </div>

          <h1 className="cs-title">
            Car Services <span className="cs-gold">Coming Soon</span>
          </h1>

          <p className="cs-subtitle">
            Premium multi-brand car servicing is on its way to{" "}
            <strong>{getDisplayLocation()}</strong>. Periodic service, AC repair,
            detailing, roadside assistance and more — all at transparent prices.
          </p>

          <div className="cs-pills">
            {serviceCategories.map((cat, i) => (
              <div key={i} className="cs-pill">
                <span>{cat.icon}</span>
                <span>{cat.name}</span>
              </div>
            ))}
          </div>
{/*
          <div className="cs-notify-form">
            <input type="email" placeholder="Enter your email to get notified" />
            <button>Notify Me</button>
          </div>
*/}
          <div className="cs-trust-row">
            <div className="cs-trust-item">
              <span className="cs-trust-num">12+</span>
              <span className="cs-trust-label">Services Planned</span>
            </div>
            <div className="cs-trust-sep" />
            <div className="cs-trust-item">
              <span className="cs-trust-num">5</span>
              <span className="cs-trust-label">Launch Cities</span>
            </div>
            <div className="cs-trust-sep" />
            <div className="cs-trust-item">
              <span className="cs-trust-num">₹0</span>
              <span className="cs-trust-label">Hidden Charges</span>
            </div>
            <div className="cs-trust-sep" />
            <div className="cs-trust-item">
              <span className="cs-trust-num">24/7</span>
              <span className="cs-trust-label">Support</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── SERVICES PREVIEW GRID ── */}
      <section className="services-grid">
        <div className="container">
          <div className="sg-header">
            <span className="sg-eyebrow">✦ Services Preview</span>
            <h2>What's Coming to {getDisplayLocation()}</h2>
            <p className="services-subtitle">
              Browse every service we're building. All will be bookable at launch in 2026.
            </p>
          </div>

          <div className="grid">
            {services.map((service) => (
              <div
                key={service.id}
                className={`service-card ${service.popular ? "popular-service" : ""}`}
              >
                <div className="card-coming-ribbon">Coming Soon</div>

                {service.badge && <span className="service-badge">{service.badge}</span>}
                {service.popular && <span className="service-badge popular">Most Popular</span>}

                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p className="service-description">{service.description}</p>

                <ul className="service-features">
                  {service.features.map((feature, index) => (
                    <li key={index}>✓ {feature}</li>
                  ))}
                </ul>

                <div className="service-footer">
                  <div className="service-price">{service.price}</div>
                  <button className="book-btn" disabled>Launching Soon</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="how-it-works">
        <div className="container">
          <h2>How It Will Work</h2>
          <div className="steps-grid">
            {[
              { n: 1, title: "Select Service", desc: "Choose from our comprehensive service packages" },
              { n: 2, title: "Book Slot", desc: "Pick a convenient date and time for your service" },
              { n: 3, title: "We Service", desc: "Expert technicians service your car at workshop or doorstep" },
              { n: 4, title: "Quality Check", desc: "Thorough quality inspection before delivery" },
            ].map((step) => (
              <div key={step.n} className="step">
                <div className="step-number">{step.n}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section className="why-choose-us">
        <div className="container">
          <h2>Why Choose Caryugo Service?</h2>
          <div className="benefits-grid">
            {benefits.map((b, i) => (
              <div key={i} className="benefit">
                <div className="benefit-icon">{b.icon}</div>
                <h3>{b.title}</h3>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Be the First to Know When We Launch</h2>
            <p>We're coming to Indore, Mhow, Ujjain, Dewas &amp; Pithampur in 2026.</p>
            <div className="cta-buttons">
              {/*<button className="cta-btn primary">Notify Me at Launch</button>*/}
              <button className="cta-btn secondary">Learn More</button>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Services;